<template>
  <div class="mt-5">
    <base-subheader>
      {{ $t("Choose floor type") + " " + forTitle }}
    </base-subheader>

    <v-radio-group
      :disabled="$store.getters.isDisabled"
      :value="room.floor_type"
      @change="$emit('input', { floor_type: $event })"
    >
      <v-radio
        v-for="item in floorOptions"
        :key="'option-' + item.slug"
        :label="item.title"
        :value="item.slug"
      ></v-radio>
    </v-radio-group>

    <!--
        STANDARD PARQUET FLOOR
        -->
    <v-expand-transition>
      <!-- <div v-if="is('standard_parquet')"> // Currently it's not possible to choose parquette
        <MandatorySliderSelector
          :id="`rooms.${room.index}.floor_parquette_slug`"
          :error="e(`rooms.${room.index}.floor_parquette_slug`)"
          :error-messages="$t('Please pick parquette {0}', [$t('for room floor')])"
          :items="$store.state.options.parquettes"
          :value="room.floor_parquette_slug"
          @input="$emit('input', { floor_parquette_slug: $event })"
        />
      </div> -->
    </v-expand-transition>
    <!--

          TILED FLOOR

          -->
    <v-expand-transition>
      <div v-if="is('tiled')">
        <div class="pt-4">
          <v-alert type="info" color="secondary" v-if="floor.tileSize" :key="floor.slug" dense>
            {{
              $t("Extra cost for tiling room floor with {0} cm ceramic tiles is {1} €/m²", [
                floor.tileSize,
                floor.surcharge,
              ])
            }}
          </v-alert>
          <div v-html="floor.tiledWorkDescription"></div>
        </div>

        <div class="mt-5">
          <span class="text-h6" v-t="'Choose ceramic tile for room floor'" />

          <span class="ml-3" v-if="tile">
            <v-chip outlined small>
              <v-icon left>mdi-check</v-icon>
              {{ tile.collection }}
              {{ tile.title }}
            </v-chip>
          </span>
        </div>
        <CeramicTileSelector
          :large-tile="room.floor_type === 'tiled_120x60'"
          :id="`rooms.${room.index}.floor_ceramic_tile_slug`"
          :error="e(`rooms.${room.index}.floor_ceramic_tile_slug`)"
          :error-messages="$t('Please pick ceramic tile {0}', [$t('for room floor')])"
          :items="$store.state.options.ceramic_tiles"
          :value="room.floor_ceramic_tile_slug"
          @input="$emit('input', { floor_ceramic_tile_slug: $event })"
        />

        <v-checkbox
          :disabled="$store.getters.isDisabled"
          :input-value="room.floor_ceramic_tile_with_baseboard"
          @change="$emit('input', { floor_ceramic_tile_with_baseboard: $event })"
          :label="
            $t('Install the baseboard at the edges of the floor') +
            ' (' +
            $t(room.floor_ceramic_tile_with_baseboard ? 'Yes' : 'No') +
            ')'
          "
          :hint="$t('Uncheck this option if you would like have tiled floor without baseboard.')"
          persistent-hint
        />
      </div>
    </v-expand-transition>
    <!--

          CLIENT SUPPLIES FLOOR

          -->
    <v-expand-transition>
      <div v-if="is('client_supplies_floor')">
        <div class="pt-4">
          <div v-html="$t('floor.clientSuppliesDescription')"></div>
        </div>
      </div>
    </v-expand-transition>
  </div>
</template>

<script>
import MandatorySliderSelector from "../MandatorySliderSelector";
import CeramicTileSelector from "../CeramicTileSelector";
import SliderSelector from "../SliderSelector";

export default {
  components: {
    SliderSelector,
    CeramicTileSelector,
    MandatorySliderSelector,
  },
  props: {
    room: {
      type: Object,
      required: true,
    },
    forTitle: {
      type: String,
      required: true,
    },
  },
  computed: {
    floorOptions() {
      return this.$store.state.options.room_floor_types;
    },
    floor() {
      return this.floorOptions.find((item) => item.slug === this.room.floor_type);
    },
    tile() {
      if (!this.tileSlug) return null;

      return this.$store.state.options.ceramic_tiles.find((item) => item.slug === this.tileSlug);
    },
  },
  methods: {
    is(slug) {
      if (slug === this.room.floor_type) return true;
      return this.room.floor_type.includes(slug);
    },
    e(key) {
      return this.$store.getters["visibleError"]("Floors", key);
    },
  },
};
</script>
